import { Component, OnInit, Input } from '@angular/core';
import { Thresholds } from '../../../models/thresholds.model';
import { Metric } from '../../../models/metric.model';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.css']
})
export class MetricsComponent implements OnInit {

  public _metrics: Metric[];

  @Input() public title: string;
  @Input() public thresholds: Thresholds;
  @Input() set metrics(value: Metric[]) {
    this._metrics = value;
    // for (let i = 0; i < this._metrics.length; i++) {
    //     let metric = this._metrics[i];
    //     if (metric.value["value"] >= this.thresholds.red[metric.name]) {
    //         metric['className'] = 'red';
    //     } 
    //     // else if (metric.value["value"] >= this.thresholds.yellow[metric.name]) {
    //     //     // metric['className'] = 'yellow';
    //     // } 
    //     else {
    //       metric['className'] = null;
    //     }
    // }


    for (let i = 0; i < this._metrics.length; i++) {
      let metric = this._metrics[i];
      
      const specificMetricName = 'ServiceLevel'; 
      const threshold = this.thresholds.red[metric.name]; 

      if (metric.name === specificMetricName) {
          if (metric.value["value"] < threshold) {
              metric['className'] = 'red';
          } 
          else {
              metric['className'] = null;
          }
      } 
      else {
          if (metric.value["value"] > threshold) {
              metric['className'] = 'red';
          }
          // else if (metric.value["value"] > this.thresholds.yellow[metric.name]) {
          //     metric['className'] = 'yellow';
          // } 
          else {
              metric['className'] = null;
          }
      }
  }

  };

  get metrics(): Metric[] {
    return this._metrics
  }

  constructor() { }

  ngOnInit() {
  console.log("thresholds values123", this.thresholds)
  }

  formatMetricDisplay(metric: any): string {
    const minutesAndSecondsMetrics = ['ASA', 'Oldest'];
  
    if (minutesAndSecondsMetrics.includes(metric.name)) {
      const totalSeconds = metric.value['value'];
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
      return `${formattedMinutes}:${formattedSeconds}`;
    }
      return metric.value['display'];
  }

}
  
